<template>
	<v-card>
		<v-container>
			<v-row>
				<h2 class="mt-6 ml-3">Imprimir Etiquetas</h2>
				<v-spacer> </v-spacer>
				<v-btn
					@click="$emit('close')"
					class="mt-3 mr-3"
					small
					fab
					color="error"
					><i style="font-size: 16px" class="fas fa-times"></i
				></v-btn>
			</v-row>
			<v-row>
				<v-col cols="12">
				</v-col>

				<v-col>
					<s-text
						label="Número Etiquetas"
						numberatedLabel
						autofocus
						v-model="quantityLabel"
						:min="0"
					>
					</s-text>
				</v-col>
			</v-row>
			<v-row>
                <v-col>
                    <b>Presione para generar e imprimir etiquetas</b>
					<v-btn color="primary" block @click="generateAndPrintLabels()" :loading="printing">
						<v-icon class="mr-3"> mdi-printer</v-icon>Generar e Imprimir Etiquetas
					</v-btn>
				</v-col>
			</v-row>


            <v-row justify="center" cols="12" style="display:none">
				<v-col cols="10" v-for="i in itemLabel">
					<qr-code class="qrCodeImg"
								:text="
									item.PrsDocumentNumber +
									valParamCaracterLabel +
									positionPresentation +
									valParamCaracterLabel +
									i.xNumber
								"
								error-level="H"
								:size="130"
							>
							</qr-code>
				</v-col>
			</v-row>

		</v-container>
	</v-card>
</template>

<script>
	import _sPrfTagPresentationSupervisorService from "../../../services/FreshProduction/PrfTagPresentationSupervisorService";
    import _sGenParam from "../../../services/General/ParameterService";
    import qrCode from "vue-qr-generator";
    import _sTurnWorKerervice from "../../../services/FreshProduction/PrfAssignTurnWorKerDetailService";
	import _TagBalerService from "@/services/FreshProduction/TagBalerService";

	export default {
        props:{
            item: null,
            typeArea: null
        },
        components :{
            qrCode
        },
		data() {
			return {
				itemsPresentation: [],
				quantityLabel: 1,
				printing: false,
                headers: [
                    {text: "Presentación", value: "TypeBoxPresentationText"},
                ],
                selected: [],
                itemLabel: [],
                valParamCaracterLabel: "",
				TrpID: 0,
				TagBaler: {},
				TypePresentationPacking: 0,
				TbrNumberEnd: 0,
				positionPresentation: 0,
				previewQr: [],
				milimetrosSpacing: 0,
			};
		},

        created() {
            console.log("recibiendo",this.item, this.typeArea);
            this.loadDataInitial()
			this.getDataLastLabelByPerson();
            this.loadParameter()
        },
		methods: {

            loadParameter() {
				_sGenParam
					.search(
						{ PrmName: "CaracterEtiquetaCajas" },
						this.$fun.getUserID()
					)
					.then((resp) => {
						if (resp.status == 200) {
							this.valParamCaracterLabel = resp.data.PrmValue;
						}
					});
			},

			loadDataInitial() {
			},

			getDataLastLabelByPerson()
			{
				return new Promise((resolve, reject) => {
					let obj = {
						TrpID : this.TrpID,
						PrsID : this.item.PrsID
					}
					_TagBalerService
					.search(obj, this.$fun.getUserID())
					.then(resp => {
						if(resp.status == 200)
						{	
							console.log("Data",resp.data);
							if(resp.data != null)
							{
								this.TbrNumberEnd = resp.data.TbrNumberEnd;
							}
							resolve();
						} else {
							reject(new Error('Error al obtener datos'));
						}
						})
						.catch(error => reject(error));
				});
			},
	

            rowClick: function(item, row) {
                this.itemLabel = [];
				if (item !== undefined) {
					this.positionPresentation = (row.index + 1);
					this.selected = [item];
					this.TrpID = item.TrpID;
					this.TypePresentationPacking = this.selected[0].TypePresentationPacking
					this.getDataLastLabelByPerson();
				}
			},

            async generateAndPrintLabels(){
                if(this.quantityLabel <=0){
                    this.$fun.alert("Ingrese cantidad de etiquetas a generar", "warning")
                    return
                }

                this.printing = true;
                
                try {
					
                    await this.getDataLastLabelByPerson();
                    this.printLabel();
                    
                    await new Promise(resolve => setTimeout(resolve, 500));
                    
                    await this.printLabelAll();

					this.$emit('close');

                } catch(error) {
                    console.error('Error al generar e imprimir etiquetas:', error);
                    this.$fun.alert(
                        "Error al procesar las etiquetas: " + (error.message || "Error desconocido"), 
                        "error"
                    );
                } finally {
                    this.printing = false;
                }
            },

			printLabel() {
				this.itemLabel = [];
				this.previewQr = [];
				
				let initital = parseInt(this.TbrNumberEnd) + 1;
				console.log('inital ', this.TbrNumberEnd)
				let end = parseInt(this.TbrNumberEnd) + parseInt(this.quantityLabel);
				
				for (var i = initital; i <= end; i++) {
					let obj = { xNumber: i };
					this.itemLabel.push(obj);
                    let previewQrObject = {
						dat : this.item.PrsDocumentNumber
					}
					this.previewQr.push(previewQrObject);
				}
				console.log('previewQr ', this.previewQr);
			},

			generatePrintHTML(imgAll) {
				let qrPerRow = 3;
				let htmlContent = `
					<html>
					<head>
						<style media='print'>
							@media print { 
								h1 {page-break-before: always;} 
							} 
							body { margin: 0; padding: 0; } 
							.qr-container { 
								width: ${this.milimetrosSpacing}mm; 
								display: flex; 
								justify-content: space-around; 
								margin: 0;
								padding: 0;
								align-items: center; 
								page-break-inside: avoid;
							}
							.qr-page { 
								display: flex;
								flex-direction: column; 
								justify-content: space-around; 
								height: 100vh;
							}
							.qr-item { 
								text-align: center; 
								width: 30%;
								display: flex;
								flex-direction: column; 
								justify-content: center; 
								align-items: center; 
							}
							.qr-item img { 
								margin-left:-20px; 
								width: 18mm; 
								height: 19mm; 
							}
							.qr-item p { 
								margin-bottom:-25px; 
								margin-top:-45px;
								font-size: 16.5px; 
								font-family: Arial, sans-serif;
								transform: rotate(90deg);
								margin-left:65px 
							}
							.page-break { 
								page-break-after: always; 
							}
						</style>
					</head>
					<body>
				`;

				imgAll.forEach((element, index) => {
					if (index % qrPerRow === 0) {
						if (index > 0) {
							htmlContent += "<div class='page-break'></div>";
						}
						htmlContent += "<div class='qr-container'>";
					}

					htmlContent += `
						<div class='qr-item'>
							<img alt='Scan me!' src='${element.currentSrc}' />
							<p>${this.previewQr[index].dat}</p>
						</div>
					`;

					if ((index + 1) % qrPerRow === 0 || index === imgAll.length - 1) {
						const remaining = qrPerRow - ((index + 1) % qrPerRow || qrPerRow);
						for (let i = 0; i < remaining; i++) {
							htmlContent += `
								<div class='qr-item'>
									<img alt='Scan me!' style='visibility: hidden;' />
									<p style='visibility: hidden;'>a</p>
								</div>
							`;
						}
						htmlContent += "</div>";
					}
				});

				htmlContent += "</body></html>";
				return htmlContent;
			},

			async printLabelAll() {
				console.log("Milimetros",this.milimetrosSpacing);
				if (this.quantityLabel <= 0) {
					this.$fun.alert(
						"La cantidad de etiquetas debe ser mayor a 0",
						"warning"
					);
					return;
				}
				
				var imgAll = document.querySelectorAll(".qrCodeImg img");

                if(imgAll.length > 0){
                    // Crear el contenido HTML para imprimir
                    const printContent = this.generatePrintHTML(imgAll);
                    
                    // Crear un iframe oculto para imprimir
                    const iframe = document.createElement('iframe');
                    iframe.style.position = 'absolute';
                    iframe.style.width = '0px';
                    iframe.style.height = '0px';
                    iframe.style.border = 'none';
                    
                    document.body.appendChild(iframe);
                    
                    const iframeDoc = iframe.contentWindow.document;
                    iframeDoc.open();
                    iframeDoc.write(printContent);
                    iframeDoc.close();
                    
                    // Esperar a que el contenido se cargue
                    iframe.onload = () => {
                        setTimeout(() => {
                            iframe.contentWindow.focus();
                            iframe.contentWindow.print();
                            
                            // Remover el iframe después de imprimir
                            setTimeout(() => {
                                document.body.removeChild(iframe);
                            }, 100);
                        }, 250);
                    };
                }

				// Guardar información de la etiqueta
				this.TagBaler.PrsID = this.item.PrsID;
				this.TagBaler.TrpID = this.TrpID;
				this.TagBaler.TbrQuantityPrint = this.quantityLabel;
				this.TagBaler.TbrStatus = 1;
				this.TagBaler.SecStatus = 1;
				this.TagBaler.UsrCreateID = this.$fun.getUserID();
				this.TagBaler.UsrUpdateID = this.$fun.getUserID();

				console.log("item save ", this.TagBaler);
				_TagBalerService
					.save(this.TagBaler, this.$fun.getUserID())
					.then(resp => {
						if(resp.status == 200){
							console.log('guardados');
						}	
					})
			},
		},
		mounted(){
			console.log("this.milimetrosSpacing mounted", this.milimetrosSpacing)

			_sGenParam
				.search(
					{ PrmName: "milimetrosinterlineadodeqr" },
					this.$fun.getUserID()
				)
				.then((resp) => {
					if (resp.status == 200) {
						this.milimetrosSpacing = resp.data.PrmValue;
						console.log("this.milimetrosSpacing", this.milimetrosSpacing)
					}
				});
		},
	};
</script>

<style>
</style>